<template>
    <div class="padding">
        <van-cell-group>
            <van-cell center title="自动在线">
                <template #title>
                    <div class="flex align-center flex-sub">
                        <span v-if="isAutoOnline">自动在线</span>
                        <span v-else-if="!isAutoOnline">手动在线</span>
                        <van-switch v-model="isAutoOnline" active-color="var(--green)" size="24"
                                    style="margin-left: 10px"/>
                    </div>
                </template>
                <template>
                    <van-button plain size="small" type="info" @click="editMode=true">编辑时间段</van-button>
                </template>
            </van-cell>
            <van-list
                    v-model="loading"
                    :finished="finished"
                    @load="loadData"
            >
                <van-checkbox-group v-model="enabledList">
                    <template v-for="[key,value] in list">
                        <van-cell v-if="!value.isDeleted" :key="key">
                            <div class="flex justify-between">
                                <van-checkbox :name="key" @click="onCheckboxChange(key)">{{ key }}</van-checkbox>
                                <van-icon v-if="editMode" name="cross" size="20px" @click="removeItem(value)"/>
                            </div>
                        </van-cell>
                    </template>
                </van-checkbox-group>
                <template v-if="editMode">
                    <van-divider/>
                    <van-form validate-trigger="onSubmit" @submit="addTime">
                        <van-field v-model="onlineHour" :formatter="formatBegin"
                                   :rules="[{ validator:beginHourValidator, message: '时间段与已有时间重合' }]"
                                   format-trigger="onBlur"
                                   input-align="right"
                                   label="上线时间"
                                   maxlength="2"
                                   placeholder="请输入开始在线时间"
                                   type="digit">
                            <template #extra>
                                <span>:00</span>
                            </template>
                        </van-field>
                        <van-field v-model="offlineHour" :formatter="formatEnd"
                                   :rules="[{ validator:endHourValidator, message: '时间段与已有时间重合' }]"
                                   format-trigger="onBlur"
                                   input-align="right"
                                   label="下线时间"
                                   maxlength="2"
                                   placeholder="请输入关闭在线时间"
                                   type="digit">
                            <template #extra>
                                <span>:00</span>
                            </template>
                        </van-field>
                        <van-cell center>
                            <template>
                                <div class="flex justify-around">
                                    <van-button native-type="button" type="default" @click="resetAdd">取消</van-button>
                                    <van-button native-type="submit" type="primary">新增</van-button>
                                </div>
                            </template>
                        </van-cell>
                    </van-form>

                </template>
            </van-list>
        </van-cell-group>
        <div class="text-center margin-tb">
            <van-button v-if="!editMode" size="large" type="primary" @click="save">保存</van-button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {
    Button,
    Cell,
    CellGroup,
    Checkbox,
    CheckboxGroup,
    Divider,
    Form,
    Icon,
    List,
    ActionSheet,
    Field,
    Popup,
    Picker,
    Tag,
    Toast,
    Dialog,
    Switch
} from 'vant';
import {loadClerkAutoOnlineSetting, saveClerkAutoOnlineSetting} from "@/api/clerk/clerk";

Vue.use(Button)
    .use(Cell)
    .use(CellGroup)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Divider)
    .use(Form)
    .use(Icon)
    .use(List)
    .use(ActionSheet)
    .use(Field)
    .use(Popup)
    .use(Picker)
    .use(Tag)
    .use(Toast)
    .use(Dialog)
    .use(Switch)

export default {
    name: "online",
    data() {
        return {
            mapChangeCount: 0,
            isAutoOnline: false,
            loading: false,
            finished: false,
            editMode: false,
            list: [],
            onlineHour: null,
            offlineHour: null,
            onlineOptionMap: new Map(),
            enabledList: [],
            onlineHourSet: new Set(),
            offlineHourSet: new Set(),
            betweenHourSet: new Set()
        }
    },
    methods: {
        //新增时间段
        addTime() {
            let onlineHour = parseInt(this.onlineHour);
            let offlineHour = parseInt(this.offlineHour);
            let item = {onlineHour, offlineHour, isDeleted: false, isEnabled: false};
            let key = this.generateKey(item);
            if (this.onlineOptionMap.has(key)) {
                this.onlineOptionMap.get(key).isDeleted = false;
            } else {
                this.onlineOptionMap.set(key, item);
                this.addHourToSet(item)
            }
            this.list = [...this.onlineOptionMap]
            this.resetAdd();
        },
        //删除时间段
        removeItem(item) {
            item.isDeleted = true;
            let onlineHour = item.onlineHour
            let offlineHour = item.offlineHour
            this.onlineHourSet.delete(onlineHour)
            this.offlineHourSet.delete(offlineHour)
            while ((onlineHour + 1) % 24 != offlineHour) {
                onlineHour = (onlineHour + 1) % 24
                this.betweenHourSet.delete(onlineHour)
            }
        },
        onCheckboxChange(key) {
            let item = this.onlineOptionMap.get(key);
            item.isEnabled = !item.isEnabled;
        },
        //检查是否与现有时间段重合
        checkIsOverlayWithExistPeriod(onlineHour, offlineHour) {
            onlineHour = parseInt(onlineHour)
            offlineHour = parseInt(offlineHour)
            let isOverlayWithExistPeriod = false
            if (this.onlineHourSet.has(onlineHour) || this.betweenHourSet.has(onlineHour)) {
                //时间段与已有时间重合
                isOverlayWithExistPeriod = true
            }
            if (this.offlineHourSet.has(offlineHour) || this.betweenHourSet.has(offlineHour)) {
                //时间段与已有时间重合
                isOverlayWithExistPeriod = true
            }
            while ((onlineHour + 1) % 24 != offlineHour) {
                onlineHour = (onlineHour + 1) % 24
                if (this.onlineHourSet.has(onlineHour) || this.betweenHourSet.has(onlineHour) || this.offlineHourSet.has(onlineHour)) {
                    //时间段与已有时间重合
                    isOverlayWithExistPeriod = true;
                    break;
                }
            }
            return isOverlayWithExistPeriod
        },
        //上线时间校验器
        beginHourValidator(val) {
            if(val<0 || val > 23){
                return  false
            }
            let onlineHour = val;
            let offlineHour = this.offlineHour;
            let key = this.generateKey({onlineHour: val, offlineHour});
            if (this.checkIsOverlayWithExistPeriod(onlineHour, offlineHour)) {
                return false
            }
            if (this.onlineOptionMap.has(key)) {
                return this.onlineOptionMap.get(key).isDeleted == true;
            }
            return true;
        },
        //下线时间校验器
        endHourValidator(val) {
            if(val<0 || val > 23){
                return  false
            }
            let onlineHour = this.onlineHour;
            let offlineHour = val;
            let key = this.generateKey({onlineHour, offlineHour: val});
            if (this.checkIsOverlayWithExistPeriod(onlineHour, offlineHour)) {
                return false
            }
            if (this.onlineOptionMap.has(key)) {
                return this.onlineOptionMap.get(key).isDeleted == true;
            }
            return true;
        },
        //重置添加时间
        resetAdd() {
            this.onlineHour = null;
            this.offlineHour = null;
            this.editMode = false;
        },
        //合理化上线时间，即如果和下线时间一致，则减一
        formatBegin(val) {
            if(val == 24){
                val = 0;
            }
            do {
                if (val == this.offlineHour) {
                    val--;
                }
                val %= 24
            } while (val == this.offlineHour)
            return val
        },
        //合理化下线时间，即如果和上线时间一致，则加一
        formatEnd(val) {
            if(val == 24){
                val = 0;
            }
            do {
                if (val == this.onlineHour) {
                    val++;
                }
                val %= 24
            } while (val == this.onlineHour)
            return val
        },
        //生成key
        generateKey(item) {
            return item.onlineHour + ':00 - ' + item.offlineHour + ':00';
        },
        //加载数据
        loadData() {
            this.loading = true;
            loadClerkAutoOnlineSetting().then(res => {
                this.loading = false;
                const data = res.data;
                if (data.code == 0) {
                    this.isAutoOnline = data.isAutoOnline;
                    for (let i = 0; i < data.list.length; i++) {
                        let key = this.generateKey(data.list[i]);
                        this.onlineOptionMap.set(key, data.list[i])
                        if (!data.list[i].isDeleted) {
                            this.addHourToSet(data.list[i])
                        }
                        if (data.list[i].isEnabled) {
                            this.enabledList.push(key)
                        }
                    }
                    this.list = [...this.onlineOptionMap]
                } else {
                    Dialog.alert({
                        title: '加载设置失败',
                        message: data.msg
                    })
                }
            })
            this.finished = true;
        },
        //将时间段添加到set里以供后续验证时间段是否重合
        addHourToSet(item) {
            this.onlineHourSet.add(item.onlineHour)
            this.offlineHourSet.add(item.offlineHour)
            let start = item.onlineHour
            let end = item.offlineHour
            while ((start + 1) % 24 != end) {
                start = (start + 1) % 24
                this.betweenHourSet.add(start)
            }
        },
        //保存设置
        save() {
            if (this.list.length == 0) {
                Dialog.alert({
                    title: '请添加最少一个时间段',
                })
            } else {
                let values = [...this.onlineOptionMap.values()];
                saveClerkAutoOnlineSetting(this.isAutoOnline, values).then(res => {
                    const data = res.data;
                    if (data.code == 0) {
                        this.onlineOptionMap.clear();
                        this.list = []
                        this.loadData()
                        Dialog.alert({
                            title: '保存成功'
                        })
                    } else {
                        this.loadData()
                        Dialog.alert({
                            title: '保存失败',
                            message: data.msg
                        })
                    }
                })
            }
        }
    }
}
</script>

<style scoped>

</style>
